import { render, staticRenderFns } from "./StatusIndicatorBorder.vue?vue&type=template&id=712ac54c&scoped=true"
import script from "./StatusIndicatorBorder.vue?vue&type=script&lang=js"
export * from "./StatusIndicatorBorder.vue?vue&type=script&lang=js"
import style0 from "./StatusIndicatorBorder.vue?vue&type=style&index=0&id=712ac54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712ac54c",
  null
  
)

export default component.exports